import { apiClient } from '@/shared/api';

import type {
  PromoProtectionPolicyRequest,
  PromoProtectionPolicyResponse,
  StackingPolicyRequest,
  StackingPolicyResponse,
} from '../model/types';

const STACKING_BASE = '/api/v1/catalog/promo/stacking-policy';
const PROTECTION_BASE = '/api/v1/catalog/promo/protection-policy';

export const getStackingPolicy = async (): Promise<StackingPolicyResponse> =>
  (await apiClient.get<StackingPolicyResponse>(STACKING_BASE)).data;

export const updateStackingPolicy = async (
  body: StackingPolicyRequest,
): Promise<StackingPolicyResponse> =>
  (await apiClient.put<StackingPolicyResponse>(STACKING_BASE, body)).data;

export const getPromoProtectionPolicy = async (): Promise<PromoProtectionPolicyResponse> =>
  (await apiClient.get<PromoProtectionPolicyResponse>(PROTECTION_BASE)).data;

export const updatePromoProtectionPolicy = async (
  body: PromoProtectionPolicyRequest,
): Promise<PromoProtectionPolicyResponse> =>
  (await apiClient.put<PromoProtectionPolicyResponse>(PROTECTION_BASE, body)).data;
